/*!
 * liveMedia.js — Oscilla Live's own folder of pictures, sounds, film and text
 * © 2026 Rob Canning — GPLv3
 *
 * On Oscilla's server, live.html takes a folder among the projects for its
 * media (_live, made the first time it is asked for: server.js
 * /api/live-media) and points the cues at it as a project's are pointed at
 * its own (projectLoader.js): images/ for image(path:plates), audio/ for
 * audio(src:...), video/, text/, and the stash beside them. On a plain
 * static host there is no folder: the cues take URLs.
 */

/**
 * Ask for the folder; the cues read from it. Its path on the server's disk, or
 * null. With a project (live.html?project=flowstates, liveProject.js): that
 * project's folder instead, when it is there.
 */
export async function useLiveMedia(asked = null) {
  let project = null, dir = null;
  if (asked) {
    try {
      const head = await fetch(`/scores/${encodeURIComponent(asked)}/preferences.json`, { method: "HEAD" });
      if (head.ok) project = asked;
      else console.warn(`[Live] no project ${asked}: Live's own folder instead`);
    } catch { /* no server */ }
  }
  if (!project) {
    let res;
    try { res = await fetch("/api/live-media", { method: "POST" }); } catch { return null; }
    if (!res.ok) return null;
    ({ project, dir } = await res.json().catch(() => ({})));
    if (!project) return null;
  }
  window.currentProject = window.currentProjectName = project;
  window.projectBase = `scores/${project}/`;
  window.audioDir = `${window.projectBase}audio/`;
  window.textDir = `${window.projectBase}text/`;
  window.videoDir = `${window.projectBase}video/`;
  window.imageDir = `${window.projectBase}images/`;
  window.sharedDir = "shared/";
  return dir ?? null;
}
